module.exports = __webpack_public_path__ + "static/media/logo-top.c3d32af5.png";